import React, { useState } from 'react'
import { updatePassword } from 'aws-amplify/auth';
import EyeIcon from 'Components/Icons/EyeIcon';
import FieldError from 'Components/Element/FieldError';

function ChangePasswordEdit({setShowEdit}) {
    const [showPassword, setShowPassword] = useState(false);
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [error, setError] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const updatePasswordFunc = async() => {
       if(oldPassword && newPassword && confirmPassword && newPassword === confirmPassword ) 
        {
            setSuccessMsg("");
            setError("");
            try {
                const updatedPass =  await updatePassword({
                oldPassword: oldPassword,
                newPassword: newPassword,
                });
                console.log("updatedPass", updatedPass);
                setConfirmPassword("");
                setNewPassword("");
                setOldPassword("");

                setSuccessMsg("Password updated successfully");
            }
            catch (error) {
                console.log("error", error);
                setError(error.message)
            }
        
        }
        else if(newPassword !== confirmPassword) {
            setError("Passwords do not match");
        }
        else if(!oldPassword || !newPassword || !confirmPassword) {
            setError("Please fill all the fields");
        }
    }

    const inputStyle = {width:'100%', boxSizing:'border-box', font:"400 14.5px/1 'IBM Plex Sans',sans-serif", padding:'12px 13px', border:'1.5px solid rgba(20,33,61,.18)', borderRadius:'3px', background:'#fffdf8'};
    const labelStyle = {display:'block', font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'#14213d', marginBottom:'7px'};

  return (
    <div className='w-full font-plexsans'>
        <h2 style={{margin:'0 0 4px', font:"400 22px/1.25 'Spectral',serif", color:'#14213d'}}>Change password</h2>
        <p style={{margin:'0 0 26px', font:"400 13.5px/1.5 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.55)'}}>Choose a strong, unique password that's at least 8 characters long. You'll be asked to sign in again afterward.</p>

        {successMsg ? <div className="mb-5" style={{font:"500 13px/1.5 'IBM Plex Sans',sans-serif", color:'#3a7d4f'}}>{successMsg}</div> : ""}
        {error ? <FieldError>{error}</FieldError> : ""}

        <div className='flex flex-col gap-4' style={{maxWidth:'360px', marginBottom:'26px', marginTop:'16px'}}>
            <div>
                <label style={labelStyle}>Current password</label>
                <input
                    type="password"
                    style={inputStyle}
                    placeholder="Password"
                    onChange={(e)=>setOldPassword(e.target.value)}
                    value = {oldPassword}
                />
            </div>
            <div>
                <label style={labelStyle}>New password</label>
                <div className="relative">
                    <input
                        type={!showPassword? "password" : "text"}
                        style={inputStyle}
                        placeholder="Password"
                        onChange={(e)=>setNewPassword(e.target.value)}
                        value = {newPassword}
                    />
                    <div className="absolute inset-y-0 right-0 flex mr-3 items-center cursor-pointer text-[rgba(20,33,61,.45)]" onClick={() => setShowPassword(!showPassword)}>
                        <EyeIcon open={showPassword} className="w-5 h-5"/>
                    </div>
                </div>
            </div>
            <div>
                <label style={labelStyle}>Confirm new password</label>
                <input
                    type="password"
                    style={inputStyle}
                    placeholder="Password"
                    onChange={(e)=>setConfirmPassword(e.target.value)}
                    value = {confirmPassword}
                />
            </div>
        </div>
        <div className='flex gap-2.5'>
            <button
                className="cursor-pointer rounded-sm transition-colors"
                style={{font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'#fffdf8', background:'#8a6231', border:'none', padding:'12px 24px'}}
                onMouseEnter={(e) => e.currentTarget.style.background = '#6d4c25'}
                onMouseLeave={(e) => e.currentTarget.style.background = '#8a6231'}
                onClick={updatePasswordFunc}>Update password</button>
            <span
            className="cursor-pointer rounded-sm"
            style={{font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.55)', border:'1px solid rgba(20,33,61,.2)', padding:'12px 22px'}}
            onClick = {()=> setShowEdit(false)}
            >Cancel</span>
        </div>
    </div>
  )
}

export default ChangePasswordEdit
